const adaptModal = modal => {
    /* Bind the close button */
    const $modal = $(modal);

    $modal.find('.modal-close').on(
        'click',
        null,
        {modal},
        event => {
            const $modal = $(event.data.modal);
            $modal.modal('hide');
        }
    );
}

export const initModals = () => {
    $('.view.modal').each(function () {
        new adaptModal(this);
    });
};

export default adaptModal;